/* eslint-disable vue/component-definition-name-casing */
// eslint-disable-next-line prefer-template
import {
  PbIcon,
  PbModal,
  PbButton,
  PbDialog,
  PbToastNotification,
  PbBadge,
} from 'vue-polar-bear';

const importComponent = path => () => import(/* webpackChunkName: "component_" */`@/components/${path}.vue`);
export default {
  install(Vue, options) {
    /**
     * PRO OLD
     */
    Vue.component('multiselect', () => import('vue-multiselect'));
    Vue.component('pro-form', importComponent('form/form'));
    Vue.component('pro-form-group', importComponent('FormGroup/FormGroup'));
    Vue.component('pro-input', importComponent('inputs/pro'));
    Vue.component('pro-input-text', importComponent('inputs/proText/proText'));
    Vue.component('pro-input-number', importComponent('inputs/proNumber/proNumber'));
    Vue.component('pro-input-email', importComponent('inputs/proEmail/proEmail'));
    Vue.component('pro-input-password', importComponent('inputs/proPassword/proPassword'));
    Vue.component('pro-input-phone', importComponent('inputs/proPhone/proPhone'));
    Vue.component('pro-input-date', importComponent('inputs/proDate/proDate'));
    Vue.component('pro-input-radio', importComponent('inputs/proRadio/proRadio'));
    Vue.component('pro-input-cpf', importComponent('inputs/proCpf/proCpf'));
    Vue.component('pro-input-cnpj', importComponent('inputs/proCnpj/proCnpj'));
    Vue.component('pro-input-cnpj-cpf', importComponent('inputs/proCnpjCpf/proCnpjCpf'));
    Vue.component('pro-input-cep', importComponent('inputs/proCep/proCep'));
    Vue.component('pro-input-color', importComponent('inputs/proColor/proColor'));
    Vue.component('pro-input-textarea', importComponent('inputs/proTextArea/proTextArea'));
    Vue.component('pro-input-checkbox', importComponent('inputs/proCheckbox/proCheckbox'));
    Vue.component('pro-select', importComponent('inputs/proSelect/proSelect'));
    Vue.component('pro-loading', importComponent('loading/Loading'));
    Vue.component('pro-button', importComponent('button/button'));
    Vue.component('card', importComponent('Card/Card'));
    Vue.component('boxModule', importComponent('boxModule/boxModule'));
    Vue.component('listModules', importComponent('ListModules/ListModules'));
    Vue.component('buttonModuleItem', importComponent('buttonModuleItem/buttonModuleItem'));
    Vue.component('modalProfile', importComponent('modalProfile/modalProfile'));
    Vue.component('modalAudit', importComponent('modalAudit/modalAudit'));
    Vue.component('modalHost', importComponent('modalHost/modalHost'));
    Vue.component('modalEntity', importComponent('modalEntity/modalEntity'));
    Vue.component('modalPassword', importComponent('modalPassword/modalPassword'));
    Vue.component('modalLogin', importComponent('modalLogin/modalLogin'));
    Vue.component('modalDashboard', importComponent('modalDashboard/modalDashboard'));
    Vue.component('modalDevelopment', importComponent('modalDevelopment/modalDevelopment'));
    Vue.component('modalFeedback', importComponent('modalFeedback/modalFeedback'));
    Vue.component('modalModule', importComponent('modalModule/modalModule'));
    Vue.component('entityList', importComponent('EntityList/EntityList'));
    Vue.component('selectEntity', importComponent('selectEntity/selectEntity'));
    Vue.component('pro-script', importComponent('Script/Script'));
    Vue.component('pro-simpleScript', importComponent('SimpleScript/SimpleScript'));
    Vue.component('portalBar', importComponent('PortalBar/PortalBar'));
    Vue.component('mirror-nf', importComponent('MirrorNF/MirrorNF'));
    Vue.component('sidebar', importComponent('Sidebar/Sidebar'));
    Vue.component('c-navbar', importComponent('Navbar/Navbar'));
    Vue.component('c-footer', importComponent('Footer/Footer'));
    Vue.component('pro-page-header', importComponent('pageHeader/PageHeader'));
    Vue.component('pro-list-group', importComponent('listGroup/ListGroup'));
    Vue.component('pro-table', importComponent('proTable/ProTable'));
    Vue.component('pro-menubar', importComponent('menubar/Menubar'));
    Vue.component('pro-menubar-tab', importComponent('menubar/MenubarTab'));
    Vue.component('box-module-edit', importComponent('ProAdmin/EditModule/EditModule'));
    Vue.component('box-item-module-edit', importComponent('ProAdmin/EditModuleItem/EditModuleItem'));
    Vue.component('pro-activity', importComponent('ProAdmin/Activity/Activity'));
    Vue.component('pro-users', importComponent('ProAdmin/Users/Users'));
    Vue.component('pro-general-message-config', importComponent('ProAdmin/General/MessageConfig'));
    Vue.component('ace-editor', importComponent('ProAdmin/AceEditor/AceEditor'));
    Vue.component('pro-banner', importComponent('Banner/Banner'));
    Vue.component('pro-folder', importComponent('fileManager/folder'));
    Vue.component('pro-file-navigation', importComponent('fileManager/fileNavigation'));
    Vue.component('pro-file', importComponent('fileManager/file'));
    Vue.component('pro-help', importComponent('Help/Help'));
    Vue.component('pro-img-lazy', importComponent('ImageLazyLoad/ImageLazyLoad'));
    Vue.component('pro-accordion', importComponent('Accordion/Accordion'));
    Vue.component('pro-finance-parse-digitableline', importComponent('ProAdmin/Finance/ParseDigitableLine'));
    Vue.component('pro-modal', importComponent('Modal/Modal'));
    Vue.component('pro-modal-stepper', importComponent('Modal/ModalStepper'));
    Vue.component('pro-modal-stepper-indicator', importComponent('Modal/ModalStepperIndicator'));
    Vue.component('pro-modal-stepper-step', importComponent('Modal/ModalStepperStep'));
    Vue.component('pro-modal-stepper-content', importComponent('Modal/ModalStepperContent'));
    Vue.component('pro-modal-examples', importComponent('Modal/examples/index'));
    Vue.component('pro-tabs-examples', importComponent('Tabs/examples/index'));
    Vue.component('pro-password-rules', importComponent('PasswordRules/PasswordRules'));
    Vue.component('pro-validation-error-alert', importComponent('ValidationErrorAlert/ValidationErrorAlert'));
    Vue.component('pro-tabs', importComponent('Tabs/Tabs'));
    Vue.component('pro-tab', importComponent('Tabs/Tab'));
    Vue.component('pro-quotas', importComponent('ProAdmin/Quotas/Quotas'));
    Vue.component('pro-invoice-configuration', importComponent('ProAdmin/Invoice/InvoiceConfiguration'));
    Vue.component('pro-profiles', importComponent('ProAdmin/Profiles/Profiles'));
    Vue.component('pro-finance-consult-digitable-line', importComponent('ProAdmin/Finance/ConsultDigitableLine'));
    Vue.component('pro-notification-automation', importComponent('ProAdmin/NotificationAutomation/NotificationAutomation'));
    Vue.component('pro-encrypt-decrypt-credentials', importComponent('ProAdmin/Finance/EncryptDecryptCredentials'));

    /**
     * POLAR BEAR
     */
    Vue.component('pb-icon', PbIcon);
    Vue.component('pb-modal', PbModal);
    Vue.component('pb-button', PbButton);
    Vue.component('pb-dialog', PbDialog);
    Vue.component('pb-toast', PbToastNotification);
    Vue.component('pb-badge', PbBadge);

    /**
     * NEW COMPONENTS
     */
    Vue.component('SimpleHeader', importComponent('SimpleHeader/SimpleHeader'));
  },
};
